// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__De3pH","rotation":"Loader_rotation__vE6FN"};